import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">EasyAutoCall</h3>
            <p className="footer-description">
              배차 알림, 이제 전화하지 말고<br />
              자동으로 보내세요.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">서비스</h4>
            <ul className="footer-links">
              <li><Link to="/services">서비스 소개</Link></li>
              <li><Link to="/pricing">요금제</Link></li>
              <li><Link to="/tts-call">TTS 전화</Link></li>
              <li><Link to="/tts-survey">TTS 설문조사</Link></li>
              <li><Link to="/dispatch-call">배차 오토콜</Link></li>
              <li><Link to="/sms-send">대량 문자 발송</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">고객지원</h4>
            <ul className="footer-links">
              <li><Link to="/support">도움말</Link></li>
              <li><Link to="/faq">자주 묻는 질문</Link></li>
              <li><Link to="/contact">문의하기</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">회사</h4>
            <ul className="footer-links">
              <li><Link to="/about">회사 소개</Link></li>
              <li><Link to="/terms">이용약관</Link></li>
              <li><Link to="/privacy">개인정보처리방침</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-company-info">
            <p>주식회사 서울소프트 (Seoul-Soft Co., Ltd.)</p>
            <p>본사/연구소: 충청북도 충주시 중앙로 80 (네오메디클리닉), 501호 | 서울사무소: 서울특별시 금천구 가산디지털1로 84, 810호</p>
            <p>대표: 노병진 | 사업자등록번호: 134-87-18556 | TEL: 02-6052-1192 | FAX: 02-600-9349</p>
          </div>
          <p className="footer-copyright">
            © 2025 Seoul-Soft. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
